import { createFileRoute } from '@tanstack/react-router';
import { PersonsOverviewPage } from '@pages/persons';

/** Personen-Übersicht-Route (/persons) — Statistik-Karten für Fans und Nutzer */
export const Route = createFileRoute('/_authenticated/persons/')({
  component: PersonsOverviewPage,
});
